<template>
	<div class="private-order-detail-page-wrapper">
		<div v-if="!isMobileView && !showEmptyState" class="private-order-detail">
			<private-order-detail-title
				v-if="!showEmptyState"
				:y-pos="yPos"
				:product="product.data"
				:is-has-description="isHasDescription"
				:is-has-content="isHasContent"
			/>

			<div class="private-order-detail-layout">
				<div class="private-order-detail-body" v-if="!showEmptyState">
					<private-order-detail-image
						:y-pos="yPos"
						:images="images"
						:active-index="activeImageIndex"
						:is-product-loading="product.isLoading"
						@select-image="handleSelectImage"
						@move-image="handleMoveImage"
						@click-image="handleShowImageModal"
					/>

					<private-order-detail-content
						:product="product.data"
						:is-product-loading="product.isLoading"
						:is-has-description="isHasDescription"
						:is-has-content="isHasContent"
					/>

					<private-order-detail-action
						:y-pos="yPos"
						:product="product.data"
						:is-product-loading="product.isLoading"
						:disabled="isAdmin"
					/>
				</div>

				<div class="private-order-detail-footer"></div>
			</div>
		</div>

		<private-order-detail-mobile
			v-else-if="isMobileView && !showEmptyState"
			:y-pos="yPos"
			:images="images"
			:active-image-index="activeImageIndex"
			:is-product-loading="product.isLoading"
			:product="product.data"
			:is-has-description="isHasDescription"
			:is-has-content="isHasContent"
			@move-image="handleMoveImage"
			@click-image="handleShowImageModal"
		/>

		<div v-if="showEmptyState" class="empty-state-wrapper">
			<img
				class="empty-state-image"
				src="https://cdn.ostock.id/img/product-not-found.png"
				alt="empty-state-image"
			/>

			<span>Oops! Produk Tidak Ditemukan</span>
		</div>

		<private-order-image-modal
			v-if="isShowImageModal"
			:images="images"
			:product-name="product.data.name"
			@close="handleShowImageModal"
			@select-image="handleSelectImage"
		/>

		<main-footer />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PrivateOrderDetailTitle from '@/components/private-orders/detail/ProductTitle.vue';
import PrivateOrderDetailImage from '@/components/private-orders/detail/ProductImage.vue';
import PrivateOrderDetailContent from '@/components/private-orders/detail/ProductContent.vue';
import PrivateOrderDetailAction from '@/components/private-orders/detail/ProductAction.vue';
import PrivateOrderImageModal from '@/components/private-orders/detail/ImageModal.vue';
import PrivateOrderDetailMobile from '@/components/private-orders/detail/mobile-view/PrivateOrderDetailMobile.vue';
import MainFooter from '@/components/homepages/Footer.vue';
import privateProductApi from '@/api/private-product';
import { youtubeParser, getYoutubeThumb } from '@/lib/helper';

export default {
	components: {
		PrivateOrderDetailTitle,
		PrivateOrderDetailImage,
		PrivateOrderDetailContent,
		PrivateOrderDetailAction,
		PrivateOrderImageModal,
		PrivateOrderDetailMobile,
		MainFooter,
	},
	data() {
		return {
			yPos: 0,
			images: [],
			isShowImageModal: false,
			product: {
				isLoading: true,
				data: {},
			},
			screenWidth: window.screen.width,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isHasFeature: 'isHasFeature',
			isDropshipper: 'isDropshipper',
			isMobileView: 'privateOrder/isMobileView',
		}),
		isPrivateOrderVisible() {
			if (this.isAdmin) return true;
			const visible = this.isDropshipper;
			return visible;
		},
		activeImageIndex() {
			let activeIndex = 0;
			this.images.forEach((item, index) => {
				if (item.active) activeIndex = index;
			});
			return activeIndex;
		},
		isHasDescription() {
			if (this.product.isLoading) return false;
			return !(
				this.product.data.description === '' || this.product.data.description === null
			);
		},
		isHasContent() {
			if (this.product.isLoading) return false;

			const marketingKit = this.product.data?.marketing_kit;
			const pages = this.product.data?.pages;

			const hasMarketingKit = marketingKit && marketingKit.visible;
			const hasPages = pages && pages.length > 0;

			return hasMarketingKit || hasPages;
		},
		showEmptyState() {
			return !this.product.isLoading && this.product.data === null;
		},
	},
	methods: {
		youtubeParser,
		getYoutubeThumb,
		...mapActions({
			setDetailActiveSection: 'privateOrder/setDetailActiveSection',
			setDetailTargetSectionId: 'privateOrder/setDetailTargetSectionId',
			setIsMobileView: 'privateOrder/setIsMobileView',
		}),
		handleScroll() {
			this.yPos = window.scrollY;

			const sections = ['product-description', 'product-content'];
			// eslint-disable-next-line no-restricted-syntax
			for (const sectionId of sections) {
				const section = document.getElementById(sectionId);
				if (section) {
					const rect = section.getBoundingClientRect();
					if (rect.top - 120 <= 0 && rect.bottom - 104 > 0) {
						this.setDetailTargetSectionId('');
						this.setDetailActiveSection(sectionId);
					}
				}
			}
		},
		handleSelectImage(selectedIndex) {
			this.images = this.images.map((item, index) => {
				let active = false;
				if (index === selectedIndex) active = true;
				else active = false;
				return {
					...item,
					active,
				};
			});
		},
		handleMoveImage(increment) {
			const activeIndex = this.activeImageIndex;
			if (activeIndex === 0 && increment === -1) return;
			if (activeIndex === this.images.length - 1 && increment === 1) return;
			this.handleSelectImage(activeIndex + increment);
		},
		handleShowImageModal(state) {
			this.isShowImageModal = state;
		},
		getProduct() {
			this.product.isLoading = true;

			const slug = this.$route.params.slug;

			const cb = (response) => {
				this.product.data = response.data;
				// eslint-disable-next-line arrow-parens
				const images = response.data.pictures.map((item) => ({
					active: false,
					type: 'image',
					url: item,
				}));
				// eslint-disable-next-line arrow-parens
				let videos = response.data.videos.filter((item) => item !== '');
				videos = videos.map((item) => {
					const ytLink = this.youtubeParser(item);
					const ytThumb = this.getYoutubeThumb(ytLink);
					return {
						active: false,
						type: 'video',
						url: ytThumb,
						videoUrl: ytLink,
					};
				});
				this.images = [...images, ...videos];
				this.images[0].active = true;
				this.product.isLoading = false;
			};

			const err = () => {
				this.product.isLoading = false;
				this.product.data = null;
			};

			privateProductApi.getDetail(slug, cb, err);
		},
		updateScreenWidth() {
			this.screenWidth = window.screen.width;

			if (this.screenWidth >= 992) {
				this.setIsMobileView(false);
			} else {
				this.setIsMobileView(true);
			}
		},
	},
	watch: {
		user: {
			handler(newUser) {
				if (newUser && !this.isPrivateOrderVisible) {
					this.$router.push({ name: 'home' });
				}
			},
			immediate: true,
		},
	},
	async mounted() {
		const user = await this.user;
		if (user && !this.isPrivateOrderVisible) {
			this.$router.push({ name: 'home' });
		}

		this.updateScreenWidth();
		this.getProduct();

		window.addEventListener('scroll', this.handleScroll);
		window.addEventListener('resize', this.updateScreenWidth);
		document.body.style.overscrollBehavior = 'none';
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.updateScreenWidth);
		document.body.style.overscrollBehavior = 'auto';
	},
};
</script>

<style scoped lang="scss">
.private-order-detail-page-wrapper {
	position: relative;
	background-color: #ffffff;
}

.private-order-detail {
	position: relative;
	background-color: #ffffff;
}

.private-order-detail-layout {
	position: relative;
	margin: 0 auto;
	padding-top: 24px;
	display: flex;
	flex-direction: column;
	width: 948px;
	max-width: 948px;

	@media screen and (min-width: 1280px) {
		width: 1188px;
		max-width: 1188px;
	}
}

.private-order-detail-title {
	width: 100%;
}

.private-order-detail-body {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	gap: 20px;

	@media screen and (min-width: 1280px) {
		gap: 32px;
	}
}

.private-order-detail-footer {
	width: 100%;
	min-height: 50px;
}

.empty-state-wrapper {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 80px;
	gap: 16px;
	margin-bottom: 32px;

	& > img.empty-state-image {
		width: 50%;
		max-width: 350px;
	}

	& > span {
		font-weight: 600;
		font-size: 18px;
		line-height: 24px;
	}
}
</style>
